module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    staticClass: "main-area"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "sm": "12"
    }
  }, [_c('h1', {
    staticClass: "centered"
  }, [_vm._v("Запись на курсы")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n        Для записи на курсы, заполните анкету, соответствующую вашему уровню подготовки\n      ")]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Поля, отмеченные звёздочкой, обязательны к заполнению")]), _vm._v(" "), _c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-tabs', {
    staticClass: "nav-fill",
    attrs: {
      "card": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Начальный уровень"
    }
  }, [_c('EntryLvlForm', {
    on: {
      "submitSuccess": _vm.successSubmit
    }
  })], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Повышение квалификации"
    }
  }, [_c('AdvancedLvlForm', {
    on: {
      "submitSuccess": _vm.successSubmit
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal"
  }, [_vm._v("\n      В ближайшее время наши менеджеры с вами свяжутся\n      "), _c('span', {
    slot: "modal-title"
  }, [_vm._v("Анкета успешно отправлена!")]), _vm._v(" "), _c('template', {
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v("Закрыть")])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df7865e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/OnlineEnrollment.vue
// module id = 244
// module chunks = 1